var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.002V15.998C7 16.544 7.446 17 7.995 17H16.005C16.545 17 17 16.551 17 15.998V6.002C17 5.456 16.554 5 16.005 5H7.995C7.455 5 7 5.449 7 6.002ZM5 6.002C5.00079 5.20727 5.31636 4.44522 5.87766 3.88261C6.43896 3.32 7.20028 3.00264 7.995 3H16.005C16.7999 3.00212 17.5615 3.3193 18.1229 3.88203C18.6843 4.44475 18.9997 5.20711 19 6.002V15.998C18.9992 16.7927 18.6836 17.5548 18.1223 18.1174C17.561 18.68 16.7997 18.9974 16.005 19H7.995C7.20011 18.9979 6.43849 18.6807 5.87708 18.118C5.31567 17.5552 5.00026 16.7929 5 15.998V6.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7H15V11H9V7ZM9 13H15V15H9V13ZM10 20.857V20H7V20.857L8.5 20L10 20.857ZM7 18H10V20H7V18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/BookIcon.d4d0252ccf9711ebc5f31b486d713c4e.svg";
export { ForwardRef as ReactComponent };